<template>
    <div class="app-container">
        <div class="wrap">
            <navBar :title="title" @handleGoBack="handleGoBack"></navBar>
            <div class="add-form">
                <van-form validate-first @failed="onFailed" @submit="onSubmit">
                    <van-field
                            v-model="formInline.carNumber"
                            label="车牌号"
                            placeholder="请输入"
                            :required="true"
                            :rules="[{ required: true, message: '请输入车牌号' }]"
                    />

                    <van-field
                            v-model="formInline.price"
                            label="费用"
                            type="number"
                            placeholder="请输入"
                            :required="true"
                            :rules="[{ required: true, message: '请输入费用' }]"
                    />

                    <van-field
                            v-model="formInline.mechanism"
                            label="所属机构"
                            placeholder="请输入"
                    />

                    <van-field
                            v-model="formInline.model"
                            label="厂牌型号"
                            placeholder="请输入"
                    />

                    <van-field
                            v-model="formInline.address"
                            label="存放地点"
                            placeholder="请输入"
                    />

                    <van-field
                            readonly
                            clickable
                            :value="formInline.buyDate"
                            label="购置日期"
                            placeholder="点击选择日期"
                            @click="showPickerDay = true"
                    />
                    <van-calendar :min-date="minDate" v-model="showPickerDay" @confirm="onConfirmDay"/>

                    <van-field
                            v-model="formInline.engineNum"
                            label="发动机号码"
                            placeholder="请输入"
                    />

                    <van-field
                            v-model="formInline.driver"
                            label="司机"
                            placeholder="请输入"
                    />

                    <textAreaInput :remark="formInline.remark" @change="handleContentChange" :title="'备注'" />


                    <van-button class="btn" block type="info" native-type="submit">提交</van-button>
                </van-form>
            </div>
        </div>
    </div>
</template>
<script>
    import {addCar,updateCar} from '@/api/oa/car';
    import {formatDate} from "@/utils/ruoyi";

    export default {
        data() {
            return {
                formInline: {
                },
                title: '新建车辆',
                showPickerDay: false,
                minDate: new Date(2010, 0, 1),
            };
        },

        mounted() {
            //回显
            this.findDetail()
        },

        methods: {
            handleGoBack() {
                this.$router.replace('/oa/car');
                this.$router.go(-1)
            },

            //回显
            findDetail() {
                const itemDetail = this.$route.query.obj ? JSON.parse(this.$route.query.obj) : '';
                if (itemDetail) {
                    this.formInline = itemDetail;
                    this.title = '编辑车辆';
                } else {
                    this.formInline = {};
                    this.title = '新建车辆';
                }
            },

            //日期确认
            onConfirmDay(value) {
                this.formInline.buyDate = formatDate(value, 'yyyy-MM-dd');
                this.showPickerDay = false;
            },

            //备注
            handleContentChange(val) {
                this.formInline.remark = val;
            },

            async onSubmit(values) {
                const params = {
                    ...values,
                    ...this.formInline,
                };
                const data = JSON.stringify(this.formInline)
                const result = this.formInline.id ? await updateCar(data) : await addCar(params);
                if (result.code == 200) {
                    this.$toast.success('添加成功');
                        this.handleGoBack();
                }
            },

            onFailed(errorInfo) {
                console.log('failed', errorInfo);
            },
        },
    };
</script>

<style lang="scss" scoped>
  .base-tit {
    padding: 20px 30px;
    font-size: 24px;
    color: #666666;
  }

  .btn {
    width: 710px;
    height: 100px;
    background: #0091ff;
    border-radius: 6px 6px 6px 6px;
    margin: 118px auto 0;
    font-size: 38px;
  }

  // 导航样式 --start
  ::v-deep .van-hairline--bottom::after {
    border-bottom: none;
  }

  ::v-deep .van-nav-bar .van-icon {
    color: #000;
  }

  ::v-deep .van-nav-bar__content {
    height: 100px;
    line-height: 100px;
  }

  ::v-deep .van-nav-bar__arrow,
  ::v-deep .van-nav-bar .van-icon {
    font-size: 32px;
  }

  // 导航样式 --end
</style>
